import { Clock } from 'lucide-react'
import { TimeOfDay } from 'constants/common'

interface BonusBadgeProps {
  matchedTimeOfDay: TimeOfDay[]
}

const timeOfDayDisplayNames: Record<TimeOfDay, string> = {
  [TimeOfDay.EARLY_MORNING]: 'Early Morning',
  [TimeOfDay.MORNING]: 'Morning',
  [TimeOfDay.AFTERNOON]: 'Afternoon',
  [TimeOfDay.EVENING]: 'Evening',
}

/**
 * Formats a list of time-of-day values into a grammatically correct string.
 * - 1 value: "Early Morning"
 * - 2 values: "Early Morning & Evening"
 * - 3+ values: "Early Morning, Afternoon & Evening"
 */
const formatTimeOfDayList = (times: TimeOfDay[]): string => {
  const names = times.map((t) => timeOfDayDisplayNames[t])

  if (names.length === 1) {
    return names[0]
  }

  if (names.length === 2) {
    return `${names[0]} & ${names[1]}`
  }

  return `${names.slice(0, -1).join(', ')} & ${names[names.length - 1]}`
}

/**
 * Displays a bonus badge when a provider in a waterfall bucket
 * has slots matching removed time-of-day filters.
 */
const BonusBadge: React.FC<BonusBadgeProps> = ({ matchedTimeOfDay }) => {
  if (!matchedTimeOfDay?.length) {
    return null
  }

  return (
    <div className="~flex ~flex-wrap ~gap-2 ~mt-[18px] ~mb-7 max-lg:~mx-2 max-lg:~my-4">
      <span className="~inline-flex ~items-center ~py-1 ~px-3 ~bg-sunrise-30 ~text-[#212529] ~rounded-full ~font-gibson ~text-sm ~font-medium ~leading-[21px]">
        <Clock size={16} className="~text-[#000000] ~shrink-0 ~mr-1" />
        <span>Has {formatTimeOfDayList(matchedTimeOfDay)} availability</span>
      </span>
    </div>
  )
}

export default BonusBadge
